import React from 'react'
import classNames from 'classnames'

interface IBubbleNavProps {
  onClick?: (e: React.MouseEvent) => void
  className?: string
  onActivate: (index: string) => void
  items: Array<{
    key: string
    value: any
  }>
  activeIndex: string
}

export default function BubbleNav({
  className,
  onActivate,
  onClick,
  items,
  activeIndex,
}: IBubbleNavProps) {
  const renderItems = (items: Array<any>) =>
    items.map(({ key, value }) => {
      return (
        <span
          key={key}
          className={classNames('nav-item', {
            active: key === activeIndex,
          })}
          onClick={() => {
            onActivate(key)
          }}
        >
          {value}
          <style jsx>
            {`
              .nav-item {
                flex: 0 0 auto;
                color: #1f2129;
                font-size: 18px;
                line-height: 24px;
                margin-right: 36px;
                cursor: pointer;
              }

              .active {
                font-weight: 500;
                transform: scale(1.5, 1.5);
                transform-origin: center center;
              }

              .active:first-child {
                transform-origin: left center;
              }
            `}
          </style>
        </span>
      )
    })

  return (
    <div
      className={classNames(`bubble-nav`, {
        [className || '']: className,
      })}
      onClick={onClick}
    >
      {renderItems(items)}
      <style jsx>
        {`
          .bubble-nav {
            height: 100%;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }
        `}
      </style>
    </div>
  )
}
